import React from 'react';
import { Card, Form, Select, Input, Row, Col, Space, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface HarassmentProps {
  form: FormInstance;
}

const Harassment: React.FC<HarassmentProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];
  const symptomsConfirmedByOptions = [
    'Physician',
    'Nurse',
    'Psychologist',
    'Therapist',
    'Other'
  ];

  return (
    <Card title="Harassment" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Did you have tangible, confirmed, physical, mental, or emotional symptoms as a direct result of the accused's treatment?"
            name={['harassment_info', 'had_symptoms']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Card type="inner" title="List up to 3 of the symptoms:">
        <Form.List name={['harassment_info', 'symptoms']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    {...restField}
                    name={[name, 'symptom']}
                    label={`${name + 1}:`}
                  >
                    <Input placeholder="Enter symptom" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              {fields.length < 3 && (
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Symptom
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      </Card>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="The symptoms were confirmed by:"
            name={['harassment_info', 'symptoms_confirmed_by']}
          >
            <Select placeholder="Select">
              {symptomsConfirmedByOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default Harassment;

